import Immutable from 'immutable';
export default (props) => {
  const { $$data, reference } = props;
  if ($$data === undefined) {
    // console.error('Missing $$data');
    return Immutable.fromJS([]);
  }
  // console.log('reference is', reference)
  return $$data !== undefined && $$data.get('availableEvents') !== undefined
    ? $$data
        .get('availableEvents')
        .filter(
          ($$event) => $$event.get('eventInternalReference') === (reference !== 'null' ? reference : null),
        )
        .groupBy(($$g) => $$g.get('themeName'))
    : undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/getAvailableEventsByReference.jsx